<template>
    <form-modal
        title="Upload Report"
        v-model="isShowUploadReport"
        @submit="uploadReport"
        :loading="loading">
        <fieldset>
            <div class="mb-3 row">
                <div class="col-md-3">
                    <label
                        for="uploadReportFile"
                        class="col-form-label"
                        >File:</label
                    >
                </div>
                <div class="col-md-8">
                    <b-file-input
                        v-model="uploadReportFile"
                        name="uploadReportFile"
                        :error="errors.file"></b-file-input>
                </div>
            </div>
        </fieldset>
    </form-modal>

    <form-modal
        title="Edit Audit"
        v-if="editAudit"
        v-model="isShowEditEditor"
        @submit="updateAudit"
        :loading="loading">
        <fieldset>
            <div class="mb-3 row align-items-center">
                <label
                    for="disabledSelect"
                    class="col-sm-3 col-form-label"
                    >Agency:</label
                >
                <div class="col-sm-9">
                    {{ editAudit.agencyName }}
                </div>
            </div>

            <div class="mb-3 row">
                <label
                    for="disabledTextInput"
                    class="col-sm-3 col-form-label"
                    >Period Under Review:</label
                >
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col">
                            <label
                                for="startMonth"
                                class="col-form-label"
                                >Start Month:</label
                            >
                            <b-date-picker
                                name="startMonth"
                                :month-picker="true"
                                :error="errors.startMonth"
                                v-model="startMonth"></b-date-picker>
                        </div>
                        <div class="col">
                            <label
                                for="endMonth"
                                class="col-form-label"
                                >End Month:</label
                            >
                            <b-date-picker
                                name="endMonth"
                                :month-picker="true"
                                :error="errors.endMonth"
                                v-model="endMonth"></b-date-picker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3 row">
                <label
                    for="disabledTextInput"
                    class="col-sm-3 col-form-label"
                    >Audit to Take Place:</label
                >
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col">
                            <label
                                for="startDate"
                                class="col-form-label"
                                >Start Date:</label
                            >
                            <b-date-picker
                                name="startDate"
                                :error="errors.startDate"
                                v-model="editAudit.startDate"></b-date-picker>
                        </div>
                        <div class="col">
                            <label
                                for="plannedEndDate"
                                class="col-form-label"
                                >End Date:</label
                            >
                            <b-date-picker
                                name="plannedEndDate"
                                :error="errors.plannedEndDate"
                                v-model="editAudit.plannedEndDate"></b-date-picker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3 row">
                <label
                    for="auditorName"
                    class="col-sm-3 col-form-label"
                    >Auditor Name:</label
                >
                <div class="col-sm-9">
                    <b-input
                        name="auditorName"
                        type="text"
                        v-model="editAudit.auditorName"
                        :error="errors.auditorName" />
                </div>
            </div>
            <div class="mb-3 row">
                <label
                    for="auditorEmailAddress"
                    class="col-sm-3 col-form-label"
                    >Auditor Email Address:</label
                >
                <div class="col-sm-9">
                    <b-input
                        name="auditorEmailAddress"
                        type="text"
                        v-model="editAudit.auditorEmailAddress"
                        :error="errors.auditorEmailAddress" />
                </div>
            </div>

            <div class="mb-3 row align-items-start">
                <label
                    for="disabledSelect"
                    class="col-sm-3 col-form-label"
                    >Notices:</label
                >
                <div class="col-sm-9 mt-2">
                    <audit-details-notices
                        :run-audits="runAudits"
                        v-model="editAudit.notices"
                        :create-audits="createAudits"
                        :audit="audit"
                        :id="id"></audit-details-notices>
                </div>
            </div>
        </fieldset>
    </form-modal>

    <div class="mt-5 mb-3 details">
        <table class="table-sm mb-3">
            <tbody>
                <tr>
                    <th>Agency:</th>
                    <td>
                        <span>
                            {{ audit.agencyName }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>Status:</th>
                    <td>
                        <span>
                            {{ audit.status }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>Period Under Review:</th>
                    <td>
                        <span class="val">
                            {{ audit.startMonth }}

                            <span class="me-1 ms-1"> through </span>
                            {{ audit.endMonth }}</span
                        >
                    </td>
                </tr>
                <tr>
                    <th>Audit to Take Place:</th>
                    <td>
                        <span class="val">
                            {{ audit.startDate }}
                            <span class="me-1 ms-1"> to </span>
                            {{ audit.plannedEndDate }}</span
                        >
                    </td>
                </tr>
                <tr>
                    <th>Auditor Contact Details:</th>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="col-12 offset-3 pb-0 pt-0">
                            <div class="row">
                                <div class="col col-auto col-title">
                                    <span class="title-bold">Name:</span>
                                </div>
                                <div class="col">
                                    <span class="val">{{ audit.auditorName }}</span>
                                </div>
                            </div>
                            <div
                                class="row"
                                v-if="audit.auditorEmailAddress">
                                <div class="col col-auto col-title">
                                    <span class="title-bold">Email:</span>
                                </div>
                                <div class="col">
                                    <span class="val">{{ audit.auditorEmailAddress }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Notices:</th>
                    <td>
                        <span
                            class="val"
                            v-if="audit.notices"
                            >{{ audit.notices.length }} notice types enabled</span
                        >
                        <span
                            class="val"
                            v-else
                            >No notice type enabled</span
                        >
                    </td>
                </tr>
            </tbody>
        </table>

        <button
            type="button"
            v-if="canEdit"
            @click.prevent="showEditEditor"
            class="btn btn-primary me-2">
            Edit
        </button>

        <button
            type="button"
            v-if="canShowClose"
            @click.prevent="closeAudit"
            class="btn btn-danger me-2">
            Close Audit
        </button>

        <button
            type="button"
            v-if="canUploadReport"
            @click="showUploadReport"
            class="btn btn-primary me-2">
            Upload Report
        </button>

        <button
            type="button"
            v-if="canShowCancel"
            @click.prevent="closeAudit"
            class="btn btn-danger me-2">
            Cancel Audit
        </button>

        <button
            type="button"
            v-if="canShowReopen"
            @click.prevent="reopenAudit"
            class="btn btn-primary me-2">
            Reopen Audit
        </button>

        <a
            v-if="canViewReport"
            :href="`api/v1/audit/file/${audit.reportFileId}`"
            class="btn btn-secondary"
            >View Report</a
        >

        <button
            type="button"
            v-if="canReplaceReport"
            @click="showUploadReport"
            class="btn btn-primary mx-2">
            Replace Report
        </button>
    </div>
</template>
<script lang="ts" setup>
import type {Audit, AuditEdit} from "@/audit.types";
import {useAuditStore} from "@/stores/auditStore";
import {clone, convertToUTC} from "@/utils";
import {useFormValidation} from "@/validation";
import {computed, onMounted, ref, watch} from "vue";
import {date, mixed, object, string} from "yup";
import AuditDetailsNotices from "./AuditDetailsNotices.vue";
import {BInput, BDatePicker, BFileInput} from "../Fields";
import {FormModal, InformationModal} from "../Misc";
import {storeToRefs} from "pinia";
const props = defineProps<{
    id: number;
    audit: Audit;
    runAudits: boolean;
    createAudits: boolean;
}>();

const emit = defineEmits(["reload"]);

const auditStore = useAuditStore();

const {loading} = storeToRefs(auditStore);
const editAudit = ref<AuditEdit>();
const uploadReportFile = ref<File | null>();

const schema = object<AuditEdit>({
    startDate: date().required().label("Start Date"),
    plannedEndDate: date()
        .required()
        .label("End Date")
        .when("startDate", (startDate, schema) => {
            if (editAudit.value!.startDate) {
                const dayAfter = new Date(new Date(editAudit.value!.startDate).getTime() + 86400000);
                return schema.min(dayAfter, "End date cannot be earlier than start date");
            }
            return schema;
        }),
    startMonth: date()
        .required()
        .label("Start Month")
        .test(
            "min-date-validation",
            () => `Start Month must be no later than ${editAudit.value?.validationStartMonth}`,
            async (startMonth) => {
                if (!editAudit.value!.validationStartMonth) {
                    return true;
                }
                var e = convertToUTC(new Date(editAudit.value!.validationStartMonth));
                e.setMonth(e.getMonth() + 1);
                e.setDate(0);
                return startMonth <= e;
            }
        ),
    endMonth: date()
        .required()
        .label("End Month")
        .when("plannedEndDate", (plannedEndDate, schema) => {
            if (editAudit.value!.plannedEndDate) {
                var endDate = new Date(editAudit.value!.plannedEndDate);
                const dayAfter = new Date(endDate.getFullYear(), endDate.getUTCMonth() + 1, 1);
                return schema.max(dayAfter, "End month cannot be later than when the Audit is taking place");
            }
            return schema;
        })
        .when("startMonth", (startMonth, schema) => {
            if (editAudit.value!.startMonth) {
                const dayAfter = new Date(editAudit.value!.startMonth.getTime() + 86400000);
                return schema.min(dayAfter, "End month has to be no earlier than start month");
            }
            return schema;
        })
        .test(
            "max-date-validation",
            () => `End Month must be no earlier than ${editAudit.value?.validationEndMonth}`,
            async (endMonth) => {
                if (!editAudit.value!.validationEndMonth) {
                    return true;
                }
                var e = convertToUTC(new Date(editAudit.value!.validationEndMonth));
                e.setMonth(e.getMonth() + 1);
                e.setDate(0);
                return endMonth >= e;
            }
        ),
    auditorName: string().required().label("Auditor Name"),
    auditorEmailAddress: string().email().label("Audit Email Address"),
});
const canShowCancel = computed(
    () =>
        props.runAudits &&
        (props.audit.statusCode == "AN" || props.audit.statusCode == "AP") &&
        (!props.audit.documents || props.audit.documents == 0)
);
const canShowClose = computed(
    () => props.runAudits && props.audit.statusCode == "AP" && props.audit.documents && props.audit.documents != 0
);

const canShowReopen = computed(
    () => props.runAudits && props.audit.statusCode == "AC"
);

const closeAudit = async function () {
    await auditStore.close(props.id!);
    await fetchDetails();
};
const reopenAudit = async function () {
    await auditStore.reopen(props.id!);
    await fetchDetails();
};



const canViewReport = computed(() => props.audit.reportFileId);

const canUploadReport = computed(() => props.runAudits && props.audit.statusCode != "AC" && !props.audit.reportFileId);

const canReplaceReport = computed(() => props.runAudits && props.audit.reportFileId && props.audit.statusCode != "AC");

const canEdit = computed(() => props.runAudits && props.audit.statusCode != "AC");

const isShowUploadReport = ref(false);

const showUploadReport = function () {
    resetValidation();
    isShowUploadReport.value = true;
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

const uploadReportSchema = object().shape({
    file: mixed().required().label("File"),
});

const uploadReport = async function () {
    if (await handleSubmit(uploadReportSchema, {file: uploadReportFile.value})) {
        await auditStore.upload(props.id!, uploadReportFile.value!);
        isShowUploadReport.value = false;
        await fetchDetails();
        uploadReportFile.value = null;
    }
};

const isShowEditEditor = ref(false);

const showEditEditor = async function () {
    resetValidation();
    editAudit.value = <AuditEdit>(<unknown>await auditStore.getById(props.id));

    editAudit.value.plannedEndDate = convertToUTC(new Date(props.audit.plannedEndDate));
    editAudit.value.startDate = convertToUTC(new Date(props.audit.startDate));
    let date = convertToUTC(new Date(props.audit.startMonth));

    startMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };

    date = convertToUTC(new Date(props.audit.endMonth));

    endMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };

    isShowEditEditor.value = true;
};
const updateAudit = async () => {
    if (await handleSubmit(schema, editAudit.value)) {
        await auditStore.update(props.id, editAudit.value!);
        await fetchDetails();
        isShowEditEditor.value = false;
    }
};

onMounted(() => {
    editAudit.value = <AuditEdit>(<unknown>clone(props.audit));
});

const fetchDetails = async () => {
    emit("reload");
};

const startMonth = ref();
const endMonth = ref();

watch(startMonth, (newStartMonth) => {
    editAudit.value!.startMonth = convertToUTC(new Date(newStartMonth.year, newStartMonth.month, 1));
});

watch(endMonth, (newEndMonth) => {
    editAudit.value!.endMonth = convertToUTC(new Date(newEndMonth.year, newEndMonth.month + 1, 0));
});
</script>

<style lang="scss">
.details {
    table {
        td,
        th {
            padding: 5px;
        }
    }
    .title-bold {
        font-weight: 700;
    }
}
</style>
